module.exports = __webpack_public_path__ + "img/headwear.b01ba94c.jpg";